import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { AdminViewTargetsStateModel } from './admin-view-targets.model'
import { TargetsService } from '../targets.service'
import { AdminGetWeeklyTargets, AdminGetMonthlyViewTargets } from './admin-view-targets.actions'

@State<AdminViewTargetsStateModel>({
  name: 'adminViewTargets',
  defaults: {
    adminWeeklyTargets: null,
    adminMonthlyViewTargets: null
  }
})
@Injectable()
export class AdminViewTargetsState {
  constructor(private targetsService: TargetsService) {}

  @Selector()
  static adminWeeklyTargets(state: AdminViewTargetsStateModel) {
    return state.adminWeeklyTargets
  }

  @Selector()
  static adminMonthlyViewTargets(state: AdminViewTargetsStateModel) {
    return state.adminMonthlyViewTargets
  }

  @Action(AdminGetWeeklyTargets)
  adminGetWeeklyTargets(
    ctx: StateContext<AdminViewTargetsStateModel>,
    { payload }: AdminGetWeeklyTargets
  ) {
    ctx.patchState({ adminWeeklyTargets: null })
    return this.targetsService.adminGetWeeklyTargets(payload).pipe(
      tap((res) => {
        ctx.patchState({ adminWeeklyTargets: res })
      })
    )
  }

  @Action(AdminGetMonthlyViewTargets)
  adminGetMonthlyViewTargets(
    ctx: StateContext<AdminViewTargetsStateModel>,
    { payload }: AdminGetMonthlyViewTargets
  ) {
    ctx.patchState({ adminMonthlyViewTargets: null })
    return this.targetsService.adminGetMonthlyViewTargets(payload).pipe(
      tap((res) => {
        ctx.patchState({ adminMonthlyViewTargets: res })
      })
    )
  }
}
